module.exports = __webpack_public_path__ + "img/img40.89ddc8c2.png";